module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box"
  }, [_c('div', {
    staticClass: "login-header"
  }, [_vm._v("\n        用户登录\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "login-body"
  }, [(_vm.loginErrorMsg) ? _c('div', {
    staticClass: "msg-error"
  }, [_c('i', {
    staticClass: "el-icon-remove"
  }), _vm._v(_vm._s(_vm.loginErrorMsg))]) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-input', {
    attrs: {
      "size": "medium",
      "required": "",
      "placeholder": "请输入帐号"
    },
    model: {
      value: (_vm.loginInfo.username),
      callback: function($$v) {
        _vm.$set(_vm.loginInfo, "username", $$v)
      },
      expression: "loginInfo.username"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.loginInfo.password),
      callback: function($$v) {
        _vm.$set(_vm.loginInfo, "password", $$v)
      },
      expression: "loginInfo.password"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入动态验证码"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.login($event)
      }
    },
    model: {
      value: (_vm.loginInfo.authentication),
      callback: function($$v) {
        _vm.$set(_vm.loginInfo, "authentication", $$v)
      },
      expression: "loginInfo.authentication"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22aa21e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Login.vue
// module id = 1385
// module chunks = 1